<div class="more-container" *ngIf="getState()">
  <nav class="fixed-bottom">
    <!-- <a (click)="setState(false)" routerLink="about-us">{{'about-us-page.about-us' | translate | uppercase}}</a> -->
    <a (click)="setState(false)" routerLink="moreinfo">{{'more-info-page.more-info' | translate | uppercase}}</a>

    <a (click)="setState(false)" routerLink="settings">{{'more-menu-page.settings' | translate | uppercase}}</a>
  </nav>
</div>
